module.exports = __webpack_public_path__ + "static/media/cert_blank.2334897f.jpg";